<app-carousel> </app-carousel>

<div class="wrapper" [ngClass.xs]="{ xs: true }">
  <ng-container
    *ngIf="
      init && (isOnline$ | async) !== null && (isOnline$ | async) === false
    "
  >
    <app-offline-message></app-offline-message>
  </ng-container>

  <h2
    class="mat-headline"
    *ngIf="mediaObserver.isActive('lt-md') || isTablet"
    style="text-align: center; margin-top: 25px"
  >
    <button
      style="text-align: center; margin: 20px"
      (click)="openMenu()"
      aria-label="Открыть боковое меню"
      mat-raised-button
      color="primary"
      style="padding: 10px; font-size: 1.5rem"
    >
      Открыть меню
    </button>
  </h2>

  <app-rolls-of-day></app-rolls-of-day>

  <h2 class="mat-headline" style="text-align: center; margin: 25px 0">
    <button
      routerLink="/discounts"
      aria-label="Открыть сраницу с акциями и скидками"
      mat-raised-button
      color="primary"
      style="font-size: 1.5rem; padding: 10px 25px"
    >
      Наши акции и скидки
    </button>
  </h2>
  <app-info-features></app-info-features>

  <div class="terms">
    <h3>Условия доставки:</h3>
    <h4>Время доставки: 11:00 - 21:45</h4>
    <p>К КАЖДОМУ ЗАКАЗУ ПЛЮС доставка 50 РУБЛЕЙ!</p>

    <p>
      Друзья! При заказе впервые мы просим предоплату в размере 300 рублей.
      Спасибо за понимание <span class="color-red">❤</span>
    </p>

    <strong>Условия минимальной доставки:</strong>
    <ul>
      <li>Орбита &mdash; от 1000 руб.</li>
      <li>Город &mdash; от 1000 руб.</li>
      <li>Верхний Чов и Нижний Чов &mdash; от 1500 руб.</li>
      <li>Эжва &mdash; от 2000 руб.</li>
      <li>Эжва Строитель &mdash; от 2500 руб.</li>
      <li>Максаковка &mdash; от 3000 руб.</li>
      <li>Затон &mdash; от 3000 руб.</li>
      <li>Яг Кар &mdash; от 3500 руб.</li>
      <li>Лесозавод &mdash; от 2000 руб.</li>
      <li>Чит &mdash; от 2000 руб.</li>
      <li>Выльгорт &mdash; от 2000 руб.</li>
      <li>Пичипашня &mdash; от 2500 руб.</li>
    </ul>

    <p>Дачи до бензиновой заправки &mdash; от 1000 руб.</p>
    <p>
      Дачи от бензиновой заправки до Нивы &mdash; от 1500 руб. (Север,
      ЧерБерезка, Черемушки, 1ое Сыктывкарское, Верба, Дружба, Рябина,
      Ручеек, Чернобыль и т.д.)
    </p>

    <strong>Платная доставка:</strong>
    <ul>
      <li>По городу &mdash; 200 руб.</li>
      <li>Ближняя/Дальняя Орбита &mdash; 200 руб.</li>
      <li>Дор участок &mdash; 200 руб.</li>
      <li>Лесозавод, Кочпон Чит &mdash; 300 руб.</li>
      <li>Выльгорт &mdash; 350 руб.</li>
      <li>Нижний и Верхний Чов &mdash; 300 руб.</li>
      <li>Краснозатонский, Эжва, Максаковка &mdash; 500 руб.</li>
    </ul>
  </div>
</div>
